import React, { useEffect, useRef, useState, useCallback } from 'react'
import { Wrapper } from '../style'
import { Table, Modal, Input, Select, message } from 'antd';
import { MakeApiCall } from "../../../../../apis";
import { useDispatch } from 'react-redux';
import { setData as setDataAction } from '../../../../../redux/actions';

const { Option } = Select;

function SpApi({ loading, list, userData, fetchList }) {
    const applicationId = 'amzn1.sp.solution.0627cb04-5be2-42e5-bf08-c0bd6cae2b8f';
    const version = 'beta';
    const redirect_uri = 'https://app.sellerview.ai/settings/marketplace-credentials?tab=spApi';
    const hasCalledApi = useRef(false);
    const dispatch = useDispatch();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [sellerName, setSellerName] = useState(localStorage.getItem("spapi_sellerName") || "");
    const [selectedRegion, setSelectedRegion] = useState(localStorage.getItem("spapi_region") || "");
    const [selectedMarketplace, setSelectedMarketplace] = useState(localStorage.getItem("spapi_marketplace") || "");

    const allMarketplaces = [
        // North America
        { id: "ATVPDKIKX0DER", name: "Amazon.com", sales_channel: "US", region_name: "NA" },
        { id: "A2EUQ1WTGCTBG2", name: "Amazon.ca", sales_channel: "Canada", region_name: "NA" },
        { id: "A1AM78C64UM0Y8", name: "Amazon.com.mx", sales_channel: "Mexico", region_name: "NA" },
        { id: "A2Q3Y263D00KWC", name: "Amazon.com.br", sales_channel: "Brazil", region_name: "NA" },

        // Europe
        { id: "A1PA6795UKMFR9", name: "Amazon.de", sales_channel: "Germany", region_name: "EU" },
        { id: "A1RKKUPIHCS9HS", name: "Amazon.es", sales_channel: "Spain", region_name: "EU" },
        { id: "A13V1IB3VIYZZH", name: "Amazon.fr", sales_channel: "France", region_name: "EU" },
        { id: "A1F83G8C2ARO7P", name: "Amazon.co.uk", sales_channel: "UK", region_name: "EU" },
        { id: "APJ6JRA9NG5V4", name: "Amazon.it", sales_channel: "Italy", region_name: "EU" },
        { id: "A1805IZSGTT6HS", name: "Amazon.nl", sales_channel: "Netherlands", region_name: "EU" },
        { id: "A2NODRKZP88ZB9", name: "Amazon.se", sales_channel: "Sweden", region_name: "EU" },
        { id: "A1C3SOZRARQ6R3", name: "Amazon.pl", sales_channel: "Poland", region_name: "EU" },
        { id: "A17E79C6D8DWNP", name: "Amazon.be", sales_channel: "Belgium", region_name: "EU" },

        // Asia-Pacific
        { id: "A21TJRUUN4KGV", name: "Amazon.in", sales_channel: "India", region_name: "FE" },
        { id: "A19VAU5U5O7RUS", name: "Amazon.sg", sales_channel: "Singapore", region_name: "FE" },
        { id: "A39IBJ37TRP1C6", name: "Amazon.au", sales_channel: "Australia", region_name: "FE" },
        { id: "A1VC38T7YXB528", name: "Amazon.co.jp", sales_channel: "Japan", region_name: "FE" },

        // Middle East
        { id: "A2VIGQ35RCS4UG", name: "Amazon.ae", sales_channel: "UAE", region_name: "FE" },
        { id: "A33AVAJ2PDY3EV", name: "Amazon.sa", sales_channel: "Saudi Arabia", region_name: "FE" },
        // { id: "A17E79C6D8DWNP", name: "Amazon.eg", sales_channel: "Egypt", region_name: "FE" },
    ];

    // --- Actions ---

    const handleDeleteCredentials = (id) => {
        Modal.confirm({
            title: 'Delete Credentials',
            content: 'Are you sure you want to delete these credentials? This action cannot be undone.',
            okText: 'Yes, Delete',
            okType: 'danger',
            cancelText: 'No',
            onOk: async () => {
                try {
                    const response = await MakeApiCall(`user-credentials/${id}`, 'delete', null, true, {}, userData?.token);
                    if (response?.status) {
                        message.success("Credentials deleted successfully");
                        // Refresh credentials list in UI
                        if (fetchList) await fetchList(); // Refresh data via parent function
                        else window.location.reload(); // Fallback refresh
                        // Update top-level user flag for SP API connection
                        try {
                            await refreshAndUpdateSpFlag();
                        } catch (e) {
                            console.error('Error refreshing SP flag after delete:', e);
                        }
                    } else {
                        message.error(response?.message || "Failed to delete credentials");
                    }
                } catch (error) {
                    message.error("Something went wrong while deleting");
                }
            },
        });
    };

    // Refresh the credentials and update the top-level user flag is_amz_sp_api_connected
    const refreshAndUpdateSpFlag = useCallback(async () => {
        try {
            // Prefer using passed-in fetchList to avoid duplicate API calls and reuse the parent cache.
            let records = null;
            if (typeof fetchList === 'function') {
                try {
                    records = await fetchList();
                } catch (e) {
                    // ignore and fallback to direct API
                    records = null;
                  console.warn('fetchList threw, falling back to API call in refreshAndUpdateSpFlag', e);
                }
            }

            if (!records) {
                const resp = await MakeApiCall('user-credentials', 'get', null, true, {}, userData?.token);
                if (resp?.status) records = resp?.data?.records || {};
            }

            const spList = (records && records['SP-API']) || [];
            const hasSp = Array.isArray(spList) && spList.length > 0;

            if (userData) {
                const currentFlag = userData?.user?.user_data?.is_amz_sp_api_connected === 1;
                if (currentFlag !== hasSp) {
                    const newUserData = {
                        ...userData,
                        user: {
                            ...userData.user,
                            user_data: {
                                ...userData.user.user_data,
                                is_amz_sp_api_connected: hasSp ? 1 : 0,
                            },
                        },
                    };
                    // Dispatch to Redux store
                    try {
                        dispatch(setDataAction(newUserData));
                    } catch (err) {
                        console.error('Error dispatching setDataAction in refreshAndUpdateSpFlag:', err);
                    }
                }
            }
        } catch (err) {
            console.error('Error fetching credentials for refreshAndUpdateSpFlag:', err);
        }
    }, [userData, dispatch, fetchList]);

    const handleMarketplaceChange = (marketplaceId) => {
        setSelectedMarketplace(marketplaceId);
        const marketplace = allMarketplaces.find(m => m.id === marketplaceId);
        if (marketplace) {
            setSelectedRegion(marketplace.region_name);
        }
    };

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    // Inside AmazonAdvertising.jsx

    useEffect(() => {
        // 1. Parse the URL query parameters
        const urlParams = new URLSearchParams(window.location.search);
        const triggerModal = urlParams.get('creds');

        if (triggerModal === 'true') {
            // 2. Open the login modal
            setIsModalOpen(true);

            // 3. Clean up the URL so it doesn't reopen if the user refreshes
            if (window.history.replaceState) {
                const cleanUrl = window.location.origin + window.location.pathname + window.location.search.replace(/&?openAdsModal=true/, '');
                window.history.replaceState({}, document.title, cleanUrl);
            }
        }
    }, []); // Runs once on mount

    const handleAmazonLogin = () => {
        localStorage.setItem("spapi_sellerName", sellerName);
        localStorage.setItem("spapi_region", selectedRegion);
        localStorage.setItem("spapi_marketplace", selectedMarketplace);

        const state = `${userData?.user?.user_data?.id}!!${selectedRegion}!!${selectedMarketplace}`;
        const baseUrl = 'https://sellercentral.amazon.in/apps/authorize/consent';
        const params = new URLSearchParams({
            application_id: applicationId,
            version,
            state,
            redirect_uri
        });
        window.location.href = `${baseUrl}?${params.toString()}`;
    };

    useEffect(() => {
        const handleCallback = async () => {
            const url = new URL(window.location.href);
            const spapi_oauth_code = url.searchParams.get('spapi_oauth_code');
            const amazon_state = url.searchParams.get('state');
            const selling_partner_id = url.searchParams.get('selling_partner_id');

            if (!spapi_oauth_code || !selling_partner_id || !amazon_state) return;

            if (!hasCalledApi.current) {
                hasCalledApi.current = true;
                const parts = amazon_state.split('!!');
                const marketplace_id = parts[2] || null;
                const savedSellerName = localStorage.getItem("spapi_sellerName") || "Unknown Seller";

                try {
                    await MakeApiCall(
                        `sp-credentials/callback-url`,
                        'post',
                        {
                            spapi_oauth_code,
                            selling_partner_id,
                            marketplace_id,
                            seller_name: savedSellerName
                        },
                        true,
                        {},
                        userData?.token
                    );

                    if (window.history.replaceState) {
                        const cleanUrl = window.location.origin + window.location.pathname;
                        window.history.replaceState({}, document.title, cleanUrl);
                    }

                    localStorage.removeItem("spapi_sellerName");
                    localStorage.removeItem("spapi_region");
                    localStorage.removeItem("spapi_marketplace");

                    // Refresh credentials UI and update top-level user flag
                    try {
                        if (fetchList) await fetchList();
                        await refreshAndUpdateSpFlag();
                    } catch (e) {
                        console.error('Error refreshing after SP callback:', e);
                    }

                    // Keep original behavior of reloading to ensure any other state is refreshed
                    window.location.reload();
                } catch (err) {
                    console.error("Error in API call:", err);
                }
            }
        };
        handleCallback();
    }, [userData?.token, fetchList, refreshAndUpdateSpFlag]);

    const columns = [
        { title: 'Credential Type', dataIndex: 'credential_type', key: 'credential_type' },
        { title: 'Seller Name', dataIndex: 'seller_name', key: 'seller_name' },
        { title: 'Region', dataIndex: 'region', key: 'region' },
        { title: 'Marketplace', dataIndex: 'marketplace', key: 'marketplace' },
        { title: 'Marketplace ID', dataIndex: 'marketplace_id', key: 'marketplace_id' },
        {
            title: 'Action',
            key: 'action',
            width: 100,
            align: 'center',
            render: (_, record) => (
                <span
                    className="cursor-pointer text-hover-danger"
                    onClick={() => handleDeleteCredentials(record.id)}
                >
                    <i className="bi bi-trash fs-3 text-danger"></i>
                </span>
            )
        }
    ];

    return (
        <Wrapper>
            <div className="row gy-5 g-xl-5">
                <div className="col-xxl-12">
                    <div className="card card-xxl-stretch mb-5 mb-xl-8">
                        <div className="card-header border-bottom-dashed">
                            <h3 className="card-title fw-bolder">Amazon SP API Credentials List</h3>
                            <div className="card-toolbar">
                                {(!list || list.length === 0) && (
                                    <button className="btn btn-light-google" onClick={openModal}>
                                        Login With Amazon
                                    </button>
                                )}
                            </div>
                        </div>
                        <div className="card-body py-2">
                            <div className="table-responsive">
                                <Table
                                    scroll={{ x: 'max-content' }}
                                    columns={columns}
                                    loading={loading}
                                    dataSource={list}
                                    rowKey="id"
                                    pagination={false}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                title="Amazon Login Details"
                open={isModalOpen}
                onCancel={closeModal}
                onOk={handleAmazonLogin}
                okText="Continue"
                okButtonProps={{
                    disabled: !sellerName.trim() || !selectedMarketplace,
                }}
            >
                <div className="mb-4">
                    <label className="fw-bold mb-2">Seller Name</label>
                    <Input
                        value={sellerName}
                        onChange={(e) => setSellerName(e.target.value)}
                        placeholder="e.g. My Brand Store"
                        className="py-2"
                    />
                </div>

                <div className="mb-4">
                    <label className="fw-bold mb-2">Select Marketplace</label>
                    <Select
                        showSearch
                        style={{ width: "100%" }}
                        value={selectedMarketplace || undefined}
                        onChange={handleMarketplaceChange}
                        placeholder="Search or Select Marketplace"
                        optionFilterProp="label"
                        className="h-40px"
                    >
                        {allMarketplaces.map(m => (
                            <Option key={m.id} value={m.id} label={`${m.name} ${m.sales_channel}`}>
                                <div className="d-flex align-items-center">
                                    <img
                                        src={`/assets/media/domainImage/${m.id}.png`}
                                        style={{ height: "18px", width: "24px", objectFit: "contain" }}
                                        loading="lazy"
                                        className="me-3"
                                        onError={(e) => {
                                            e.target.src = "/assets/media/domainImage/red-flag.png";
                                        }}
                                        alt={m.name}
                                    />
                                    <span>
                                        {m.name} <span className="text-muted fs-8">({m.sales_channel})</span>
                                    </span>
                                </div>
                            </Option>
                        ))}
                    </Select>
                </div>
            </Modal>
        </Wrapper>
    )
}

export default SpApi;

